import { render } from "./TheSave.vue?vue&type=template&id=77a7c40c&scoped=true"
import script from "./TheSave.vue?vue&type=script&lang=js"
export * from "./TheSave.vue?vue&type=script&lang=js"

import "./TheSave.vue?vue&type=style&index=0&id=77a7c40c&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a7c40c"]])

export default __exports__